import React, { useState } from "react";
import { Calculator, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { apiErr } from "../../lib/apiErr";
import { fmt } from "./pricingCatalog";

const SEL = "w-full rounded-xl border border-line bg-white px-3 py-2 text-sm outline-none focus:border-brand";

export default function QuoteSimulator({ catalog, featureMap }) {
  const services = catalog.providers.flatMap((p) => p.services.map((s) => ({ ...s, provider: p.label })));
  const [f, setF] = useState({ service_id: services[0]?.id, component_id: services[0]?.components[0]?.id, qty: "", variant: "", feature: "" });
  const [res, setRes] = useState(null);
  const [busy, setBusy] = useState(false);
  const svc = services.find((s) => s.id === f.service_id);
  const set = (k, v) => setF((x) => ({ ...x, [k]: v }));
  const run = async () => {
    setBusy(true);
    const body = { service_id: f.service_id, component_id: f.component_id };
    if (f.qty !== "") body.qty = Number(f.qty);
    if (f.variant) body.variant = f.variant;
    if (f.feature) body.feature = f.feature;
    try { setRes((await api.post("/admin/pricing-catalog/quote", body)).data); } catch (e) { toast.error(apiErr(e, "Gagal menghitung")); } finally { setBusy(false); }
  };
  const rows = res && [["Biaya dasar", `$${fmt(res.base_usd, 6)}`], [`Margin ${res.margin_pct}%`, `$${fmt(res.margin_usd, 6)}`], [`PPN ${res.tax_pct}%`, `$${fmt(res.tax_usd, 6)}`], ["Total jual", `$${fmt(res.total_usd, 6)}`], ["Kredit eksak", fmt(res.credits_exact, 4)]];
  return (
    <div className="aivora-card p-5" data-testid="quote-simulator">
      <p className="flex items-center gap-2 text-sm font-bold text-slate-900"><Calculator size={15} /> Simulator kuotasi</p>
      <p className="text-xs text-slate-500">Hitung kredit lewat rumus server. Kosongkan qty untuk memakai qty flat dari docs (mis. gpt-image high, nano banana 1.290 token).</p>
      <div className="mt-4 grid gap-3 md:grid-cols-5">
        <select className={SEL} value={f.service_id} onChange={(e) => { const s = services.find((x) => x.id === e.target.value); setF((x) => ({ ...x, service_id: s.id, component_id: s.components[0]?.id })); }} data-testid="quote-service">
          {services.map((s) => <option key={s.id} value={s.id}>{`${s.provider} · ${s.label}`}</option>)}
        </select>
        <select className={SEL} value={f.component_id} onChange={(e) => set("component_id", e.target.value)} data-testid="quote-component">
          {svc?.components.map((c) => <option key={c.id} value={c.id}>{c.label}</option>)}
        </select>
        <input className={SEL} type="number" min="0" placeholder="qty (kosong = flat)" value={f.qty} onChange={(e) => set("qty", e.target.value)} data-testid="quote-qty" />
        <input className={SEL} placeholder="variant (low/medium/high)" value={f.variant} onChange={(e) => set("variant", e.target.value)} data-testid="quote-variant" />
        <select className={SEL} value={f.feature} onChange={(e) => set("feature", e.target.value)} data-testid="quote-feature">
          <option value="">Fitur (opsional)</option>
          {Object.keys(featureMap || {}).map((k) => <option key={k} value={k}>{k}</option>)}
        </select>
      </div>
      <button onClick={run} disabled={busy} className="btn-grad mt-4 flex items-center gap-1.5 rounded-xl px-4 py-2 text-xs font-bold" data-testid="quote-run">{busy && <Loader2 size={13} className="animate-spin" />} Hitung</button>
      {res && (
        <div className="mt-4 grid gap-3 md:grid-cols-6" data-testid="quote-result">
          {rows.map(([l, v]) => <div key={l} className="rounded-xl bg-slate-50 p-3"><p className="text-[11px] uppercase tracking-wider text-slate-500">{l}</p><p className="text-sm font-bold text-slate-800">{v}</p></div>)}
          <div className="rounded-xl bg-slate-900 p-3 text-white"><p className="text-[11px] uppercase tracking-wider opacity-70">Kredit ditagih</p><p className="text-xl font-black" data-testid="quote-credits">{res.credits}</p></div>
          <p className="text-[11px] text-slate-400 md:col-span-6">{res.path} · qty {fmt(res.qty, 2)} / basis {fmt(res.qty_basis, 0)} {res.unit}</p>
        </div>
      )}
    </div>
  );
}
